import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis, destroyLenis } from "@/lib/scroll";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { Pricing } from "@/components/landing/Pricing";
import { Differentials } from "@/components/landing/Differentials";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Gallery } from "@/components/landing/Gallery";
import { About } from "@/components/landing/About";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFab } from "@/components/landing/WhatsAppFab";
import Privacidade from "@/pages/legal/Privacidade";
import Cookies from "@/pages/legal/Cookies";
import Termos from "@/pages/legal/Termos";

function Landing() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Pricing />
        <Differentials />
        <HowItWorks />
        <Gallery />
        <About />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/politica-de-privacidade" element={<Privacidade />} />
        <Route path="/politica-de-cookies" element={<Cookies />} />
        <Route path="/termos-e-condicoes" element={<Termos />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
